module.exports = __webpack_public_path__ + "img/L0_light.22740437.svg";